import { z } from 'zod';

export const userSummarySchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  roleKey: z.string(),
  roleName: z.string(),
  active: z.boolean(),
  mfaEnabled: z.boolean().default(false),
});
export type UserSummary = z.infer<typeof userSummarySchema>;

export const updateUserSchema = z.object({
  roleKey: z.string().min(1).optional(),
  active: z.boolean().optional(),
});
export type UpdateUser = z.infer<typeof updateUserSchema>;

export const assigneeSchema = z.object({ id: z.string(), name: z.string() });
export type Assignee = z.infer<typeof assigneeSchema>;
